<template>
    <v-dialog v-model="getDialog" :width="$vuetify.breakpoint.smAndDown ? '100%' : 520"
        :fullscreen="$vuetify.breakpoint.xs" persistent @keydown.esc="chiudi()" @keydown.ctrl.enter="formSubmit">
        <v-form ref="formIns" @submit.prevent="formSubmit()" lazy-validation style="height:100%!important;">
            <v-card class="dialog-card d-flex flex-column" :class="{ 'dialog-mobile': $vuetify.breakpoint.smAndDown }"
                style="height:100%;">

                <!-- ════════════════════════════════════════
                     HEADER: colore dinamico per tipologia
                ════════════════════════════════════════ -->
                <v-card-title class="pa-0 flex-shrink-0">
                    <!-- Banner "completato" -->
                    <div v-if="dati.completato" class="completato-banner">
                        <v-icon small color="white" class="mr-1">done_all</v-icon>
                        Attività completata
                    </div>

                    <div class="header-content" :style="{ backgroundColor: coloreEvento(dati.tipologia) }">
                        <!-- Utente -->
                        <div class="header-meta">
                            <v-icon small color="white" class="mr-1">person</v-icon>
                            <span>{{ utente }}</span>
                        </div>

                        <!-- Selettore tipologia come chip-toggle -->
                        <div class="tipo-toggle mt-2" v-if="!inputReadonly()">
                            <button v-for="tipo in tipiOre" :key="tipo" type="button" class="tipo-btn"
                                :class="{ 'tipo-btn--active': dati.tipologia === tipo }" @click="dati.tipologia = tipo">
                                <v-icon x-small class="mr-1">{{ iconaTipo(tipo) }}</v-icon>
                                {{ tipo }}
                            </button>
                        </div>
                        <!-- Readonly: mostra solo la tipologia attiva -->
                        <div v-else class="tipo-toggle mt-2">
                            <span class="tipo-btn tipo-btn--active tipo-btn--readonly">
                                <v-icon x-small class="mr-1">{{ iconaTipo(dati.tipologia) }}</v-icon>
                                {{ dati.tipologia }}
                            </span>
                        </div>
                    </div>
                </v-card-title>

                <!-- ════════════════════════════════════════
                     BODY: scrollabile su mobile
                ════════════════════════════════════════ -->
                <v-card-text class="flex-grow-1 pa-3 pa-sm-4" style="overflow-y:auto;">
                    <v-container fluid class="pa-0">
                        <v-row dense>

                            <!-- ── SEZIONE 1: Chi / Cosa ── -->
                            <!-- <v-col cols="12">
                                <div class="section-label">
                                    <v-icon x-small class="mr-1">info_outline</v-icon>Cliente
                                </div>
                            </v-col> -->

                            <!-- Cliente -->
                            <v-col cols="12">
                                <v-autocomplete :items="clienti" label="Cliente" item-text="ragSoc" item-value="ragSoc"
                                    v-model="clienteSel" return-object ref="inputCliente" clearable hide-details="auto"
                                    dense outlined @change="setCliente()" :disabled="inputReadonly()"
                                    prepend-inner-icon="business" />
                            </v-col>

                            <!-- Titolo -->
                            <v-col cols="12">
                                <v-text-field outlined dense label="Titolo" v-model="dati.titolo" hide-details="auto"
                                    rows="2" @keydown.ctrl.enter.prevent="formSubmit" :readonly="inputReadonly()"
                                    prepend-inner-icon="notes" />
                            </v-col>

                            <!-- Descrizione -->
                            <v-col cols="12">
                                <v-textarea outlined dense label="Descrizione" v-model="dati.descrizione"
                                    hide-details="auto" auto-grow rows="2" @keydown.ctrl.enter.prevent="formSubmit"
                                    :readonly="inputReadonly()" prepend-inner-icon="notes" />
                            </v-col>

                            <!-- ── SEZIONE 2: Quando ── -->
                            <v-col cols="12" class="mt-2 mb-0 pb-0">
                                <div class="section-label">
                                    <v-icon x-small class="mr-1">schedule</v-icon>Quando
                                </div>
                            </v-col>

                            <!-- Data -->
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="dati.data" label="Data" type="date" dense outlined
                                    hide-details="auto" :rules="[rules.required]" :readonly="inputReadonly()"
                                    prepend-inner-icon="event" />
                            </v-col>

                            <!-- Toggle "Tutto il giorno" ben visibile -->
                            <v-col cols="12">
                                <v-btn-toggle :value="giornoInteroToggle" @change="onGiornoInteroToggle" mandatory
                                    dense class="giorno-toggle" :disabled="inputReadonly()">
                                    <v-btn value="orario" small :disabled="inputReadonly()">
                                        <v-icon small class="mr-1">access_time</v-icon>
                                        Con orario
                                    </v-btn>
                                    <v-btn value="intero" small :disabled="inputReadonly()">
                                        <v-icon small class="mr-1">wb_sunny</v-icon>
                                        Tutto il giorno
                                    </v-btn>
                                </v-btn-toggle>
                            </v-col>

                            <!-- Orari (visibili solo se NON tutto il giorno) -->
                            <template v-if="!dati.giornoIntero">
                                <v-col cols="5">
                                    <v-menu v-model="menuOraInizio" :close-on-content-click="false" offset-y
                                        max-width="290px" min-width="290px" :disabled="inputReadonly()">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="dati.oraInizio" label="Inizio" dense outlined
                                                hide-details="auto" clearable v-bind="attrs" placeholder="09:00"
                                                :readonly="inputReadonly()" @blur="normalizzaOra('oraInizio')"
                                                prepend-inner-icon="login">
                                                <template v-slot:append>
                                                    <v-icon tabindex="-1" small @click="menuOraInizio = true">
                                                        keyboard_arrow_down
                                                    </v-icon>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <v-time-picker v-if="menuOraInizio" v-model="dati.oraInizio" full-width
                                            @click:minute="menuOraInizio = false" format="24hr" />
                                    </v-menu>
                                </v-col>

                                <v-col cols="1" class="d-flex align-center justify-center pa-0 mt-1">
                                    <span style="font-size:1.1rem; color:#9e9e9e;">→</span>
                                </v-col>

                                <v-col cols="5">
                                    <v-menu v-model="menuOraFine" :close-on-content-click="false" offset-y
                                        max-width="290px" min-width="290px" :disabled="inputReadonly()">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="dati.oraFine" label="Fine" dense outlined
                                                hide-details="auto" clearable v-bind="attrs" placeholder="10:00"
                                                :readonly="inputReadonly()" @blur="normalizzaOra('oraFine')"
                                                prepend-inner-icon="logout">
                                                <template v-slot:append>
                                                    <v-icon tabindex="-1" small @click="menuOraFine = true">
                                                        keyboard_arrow_down
                                                    </v-icon>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <v-time-picker v-if="menuOraFine" v-model="dati.oraFine" full-width
                                            @click:minute="menuOraFine = false" format="24hr" />
                                    </v-menu>
                                </v-col>

                                <!-- Chips durata rapida -->
                                <!-- <v-col cols="12" v-if="!inputReadonly()">
                                    <div class="durata-chips">
                                        <span class="durata-label">Durata rapida:</span>
                                        <v-chip v-for="d in durateRapide" :key="d.label" x-small outlined class="ml-1"
                                            :color="coloreEvento(dati.tipologia)" @click="impostaDurata(d.minuti)">{{
                                                d.label }}</v-chip>
                                    </div>
                                </v-col> -->
                            </template>

                            <!-- ── SEZIONE 3: Dettagli ── -->
                            <v-col cols="12" class="mt-2 mb-0 pb-0">
                                <div class="section-label">
                                    <v-icon x-small class="mr-1">tune</v-icon>Dettagli
                                </div>
                            </v-col>

                            <!-- Destinazione e importo -->
                            <v-col cols="7">
                                <v-select :items="destinazioni" v-model="dati.destinazione" label="Destinazione" dense
                                    outlined hide-details="auto" :readonly="inputReadonly()"
                                    prepend-inner-icon="place" />
                            </v-col>

                            <v-col cols="4">
                                <v-text-field v-model="dati.importoPrevisto" label="Importo €" dense outlined
                                    hide-details="auto" :readonly="inputReadonly()" prepend-inner-icon="euro" />
                            </v-col>

                            <v-col cols="1" class="d-flex align-center justify-center">
                                <v-btn icon small
                                    v-tooltip.bottom="'Calcola da tariffa cliente (se tutto il giorno stima 8h)'"
                                    @click="getPrezzoCliente()" :disabled="inputReadonly()">
                                    <v-icon small>cloud_sync</v-icon>
                                </v-btn>
                            </v-col>

                            <!-- Partecipanti -->
                            <v-col cols="12">
                                <v-autocomplete outlined dense label="Partecipanti" v-model="dati.partecipanti"
                                    hide-details="auto" :items="utenti" multiple clearable :disabled="inputReadonly()"
                                    prepend-inner-icon="group" small-chips deletable-chips />
                            </v-col>

                            <!-- Completato -->
                            <v-col cols="12">
                                <v-btn block :outlined="!dati.completato" :color="dati.completato ? 'green' : 'grey'"
                                    :dark="dati.completato" small :disabled="inputReadonly()"
                                    @click="dati.completato = !dati.completato" class="completato-btn">
                                    <v-icon small class="mr-2">
                                        {{ dati.completato ? 'done_all' : 'radio_button_unchecked' }}
                                    </v-icon>
                                    {{ dati.completato ? 'Completata' : 'Segna come completata' }}
                                </v-btn>
                            </v-col>

                        </v-row>
                    </v-container>
                </v-card-text>

                <!-- ════════════════════════════════════════
                     FOOTER sticky con azioni
                ════════════════════════════════════════ -->
                <v-divider />
                <v-card-actions class="flex-shrink-0 pa-3">
                    <v-btn text @click="chiudi()" :small="$vuetify.breakpoint.xs">
                        <v-icon small class="mr-1">close</v-icon>
                        Annulla
                    </v-btn>

                    <v-btn text icon color="red lighten-1" @click="elimina" :disabled="inputReadonly() || prog == -1"
                        v-tooltip.bottom="'Elimina attività'">
                        <v-icon>delete_outline</v-icon>
                    </v-btn>

                    <v-spacer />

                    <!-- Shortcut hint (solo desktop) -->
                    <span v-if="!$vuetify.breakpoint.smAndDown" class="caption grey--text mr-2">
                        Ctrl+↵ per salvare
                    </span>

                    <v-btn color="primary" type="submit" :disabled="inputReadonly()" :small="$vuetify.breakpoint.xs">
                        <v-icon small class="mr-1">save</v-icon>
                        Salva
                    </v-btn>
                </v-card-actions>

            </v-card>
        </v-form>
    </v-dialog>
</template>


<script>
import {
    get_tasks,
    save_task,
    del_task,
} from "@/api/api.calendar.js";

import storage from "@/services/storage";
import mixinCalendar from "@/views/calendar/mixinCalendar";

export default {
    props: {
        dialog: { type: Boolean, default: false },
        data: { type: String, default: "" },
        prog: { type: Number, default: 0 },
        clienti: {
            type: Array, default: () => { return [] },
        },
        utenti: {
            type: Array, default: () => { return [] },
        },
        utente: { type: String, default: "" },
        // Voce da cui precompilare il form quando prog === -1 e si tratta di una duplicazione
        // (per un inserimento "vuoto" normale resta null)
        sorgente: { type: Object, default: null },
    },

    mixins: [mixinCalendar],

    data: () => ({
        dati: {},
        menuOraInizio: false,
        menuOraFine: false,

        clienteSel: {},
        tipiImporto: ["Orario", "Totale"],
        destinazioni: ["Cliente", "Ufficio"],
        tipiOre: ["Attivita", "Appuntamento", "Nota", "Riunione"],
        durateRapide: [],

        rules: {},
    }),

    computed: {
        getDialog: {
            get: function () {
                return this.dialog;
            },
            set: function (value) {
                if (!value) {
                    this.chiudi();
                }
            },
        },

        username: {
            get: function () {
                return storage.getUsername();
            },
        },

        giornoInteroToggle() {
            return this.dati.giornoIntero ? 'intero' : 'orario';
        },
    },

    watch: {
        async dialog(val) {
            if (val) {
                this.$nextTick(() => this.$refs.formIns.resetValidation());

                await this.caricaDati();

                this.focusCliente();
            }
        },
    },

    created() {
        // recupero i dati dal mixin
        this.dati = this.getDatiTask();
        this.durateRapide = this.getDurateRapide();
        this.rules = this.getRules();
    },

    methods: {
        async caricaDati() {
            // Reset
            this.clienteSel = [];

            // Controllo nuovo: riparto sempre da un oggetto pulito, altrimenti campi come
            // "tutto il giorno" o gli orari restano impostati con il valore dell'attività
            // aperta in precedenza nello stesso dialog.
            if (this.prog == -1) {
                if (this.sorgente) {
                    // Duplicazione: riparto dai dati dell'attività originale
                    this.dati = {
                        data: this.data,
                        prog: -1,
                        titolo: this.sorgente.titolo,
                        descrizione: this.sorgente.descrizione,
                        utenteCreazione: this.utente,
                        importoPrevisto: this.sorgente.importoPrevisto || 0,
                        destinazione: this.sorgente.destinazione,
                        tipologia: this.sorgente.tipologia,
                        oraInizio: this.sorgente.oraInizio,
                        oraFine: this.sorgente.oraFine,
                        giornoIntero: this.sorgente.giornoIntero,
                        codAnagrafica: this.sorgente.codAnagrafica || "",
                        completato: false,
                        partecipanti: this.sorgente.utenti
                            ? this.sorgente.utenti.split(',')
                            : [this.utente],
                    };
                    this.clienteSel = this.clienti.find(f => f.codAnagrafica == this.dati.codAnagrafica);
                } else {
                    this.dati = this.getDatiTask();
                    this.dati.data = this.data;
                    this.dati.prog = this.prog;
                    this.dati.utenteCreazione = this.utente;
                    this.dati.partecipanti = [this.utente];
                    this.dati.tipologia = this.tipiOre[0];
                }
            }
            else {
                let par = "dettaglio/" + this.data + "/" + this.prog;

                try {
                    let res = await get_tasks(par);
                    this.dati = res.data;
                    // Il campo Data va confrontato/editato in formato "YYYY-MM-DD" (input type="date")
                    this.dati.data = this.dati.data.substring(0, 10);

                    // Seleziono il cliente
                    this.clienteSel = this.clienti.find(
                        (f) => f.codAnagrafica == this.dati.codAnagrafica
                    );
                    this.dati.partecipanti = this.dati.utenti.split(',');
                } catch (error) {
                    console.log(error);
                    this.$toast.info(this.$functions.getErrorMsg(error));
                }
            }
        },

        async formSubmit() {
            if (this.$refs.formIns.validate() === false) return;

            if (!this.clienteSel && !this.dati.descrizione && !this.dati.titolo) {
                this.$toast.alert("Inserire un cliente, un titolo o una descrizione");
                return;
            }

            //  o "Tutto il giorno" OPPURE un orario valido
            if (!this.dati.giornoIntero) {
                if (!this.dati.oraInizio || !this.dati.oraFine) {
                    this.$toast.alert("Inserire un orario valido");
                    return;
                }

                this.normalizzaOra("oraInizio");
                this.normalizzaOra("oraFine");

                const isValidTime = (t) => /^([01]\d|2[0-3]):([0-5]\d)$/.test(t);
                if (!isValidTime(this.dati.oraInizio) || !isValidTime(this.dati.oraFine)) {
                    this.$toast.alert("Formato orario non valido (hh:mm)");
                    return;
                }

                // l'ora di fine deve essere maggiore dell'ora di inizio
                const toMinutes = (t) => {
                    const [h, m] = t.split(":").map(Number);
                    return h * 60 + m;
                };

                if (toMinutes(this.dati.oraFine) <= toMinutes(this.dati.oraInizio)) {
                    this.$toast.alert("L'orario di fine deve essere successivo a quello di inizio");
                    return;
                }
            }

            this.dati.utenti = this.dati.partecipanti.join(',');
            if (isNaN(this.dati.importoPrevisto)) this.dati.importoPrevisto = 0;

            // Se sto modificando un'attività esistente e ho cambiato la data, lo segnalo al
            // backend (che sposta la riga) invece di lasciare che salvi una copia sulla data
            // originale. NuovaData sul backend è un DateTime non nullable: quando non sto
            // spostando nulla la valorizzo uguale a Data (mai interpretata come spostamento),
            // MAI a null (romperebbe la deserializzazione).
            if (this.prog > 0 && this.dati.data !== this.data) {
                this.dati.nuovaData = this.dati.data;
                this.dati.data = this.data;
            } else {
                this.dati.nuovaData = this.dati.data;
            }

            await save_task(this.dati, "");
            this.chiudi(true);
        },

        chiudi(aggiorna) {
            // Il dialog si nasconde ma il contenuto resta montato: se un campo (es. Cliente,
            // autofocusato all'apertura) ha ancora il focus quando chiudiamo, non riceve mai un
            // vero blur nativo e resta "bloccato" internamente come focused. Il prossimo .focus()
            // alla riapertura diventa quindi un no-op. Forzo il blur qui per resettarlo sempre.
            if (document.activeElement && typeof document.activeElement.blur === 'function') {
                document.activeElement.blur();
            }
            this.dati = {};
            this.$emit("chiudi", aggiorna);
        },

        focusCliente() {
            // Doppio rinvio (nextTick + rAF): il campo è dentro un v-dialog con transizione,
            // un solo nextTick a volte anticipa il montaggio/layout effettivo del campo e il
            // focus() risultava "perso" nel nulla.
            this.$nextTick(() => {
                requestAnimationFrame(() => {
                    this.$refs.inputCliente && this.$refs.inputCliente.focus();
                });
            });
        },

        onGiornoInteroToggle(v) {
            this.dati.giornoIntero = (v === 'intero');
            if (this.dati.giornoIntero) {
                this.dati.oraInizio = null;
                this.dati.oraFine = null;
            }
        },

        async elimina() {
            if (this.prog == -1) return;

            let confirm = await this.$confirm.open(
                "Elimina",
                "Vuoi eliminare l'attività ?"
            );

            if (!confirm) return;

            try {
                await del_task(this.data + "/" + this.prog);

                // Chiudo la videata
                this.chiudi(true);
            } catch (error) {
                this.$toast.alert(this.$functions.getErrorMsg(error));
            }
        },

        setCliente() {
            if (!this.clienteSel) {
                this.dati.codAnagrafica = "";
            } else {
                this.dati.codAnagrafica = this.clienteSel.codAnagrafica;
            }
        },

        normalizzaOra(campo) {
            let val = this.dati[campo];
            this.$set(this.dati, campo, this.$functions.normalizzaOra(val))
            if (!this.dati[campo]) return;
            if (campo == "oraInizio" && (this.dati.oraFine == "" || this.dati.oraFine == null)) {
                let [h, m] = this.dati.oraInizio.split(":").map(Number);
                let date = new Date();
                date.setHours(h, m || 0, 0, 0);
                date.setHours(date.getHours() + 1);

                let hh = String(date.getHours()).padStart(2, "0");
                let mm = String(date.getMinutes()).padStart(2, "0");

                this.$set(this.dati, "oraFine", `${hh}:${mm}`)
            }
        },

        /*         impostaDurata(minuti) {
                    if (!this.dati.oraInizio) return;
                    this.normalizzaOra("oraInizio");
                    if (!this.dati.oraInizio) return;
                    const [h, m] = this.dati.oraInizio.split(":").map(Number);
                    const date = new Date();
                    date.setHours(h, m + minuti, 0, 0);
                    this.$set(this.dati, "oraFine",
                        `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`
                    );
                }, */

        coloreEvento(tipo) {
            switch (tipo) {
                case 'Appuntamento': return '#F9A825';
                case 'Nota': return '#009688';
                case 'Attivita': return '#8BC34A';
                case 'Riunione': return '#FF5722';
                default: return 'secondary';
            }
        },

        iconaTipo(tipo) {
            const icone = {
                Appuntamento: 'event',
                Nota: 'sticky_note_2',
                Attivita: 'task_alt',
                Riunione: 'groups',
            };
            return icone[tipo] || 'circle';
        },

        inputReadonly() {
            // ritorna true se il controllo non può essere modificato (l'utente corrente non è proprietario dell'evento)
            if (!this.dati.utenti) return false;
            let canEdit = this.dati.utenti.includes(this.username) || this.dati.utenteCreazione == this.username;
            return !canEdit;
        },

        getPrezzoCliente() {
            if (!this.dati.codAnagrafica || this.dati.codAnagrafica == "") return;

            if (!this.dati.oraInizio || !this.dati.oraFine) {
                this.dati.importoPrevisto = this.clienteSel.importo * 8;
                return;
            }

            const [hInizio, mInizio] = this.dati.oraInizio.split(':').map(Number)
            const [hFine, mFine] = this.dati.oraFine.split(':').map(Number)

            const inizio = new Date(0, 0, 0, hInizio, mInizio)
            const fine = new Date(0, 0, 0, hFine, mFine)

            let diffMinuti = (fine - inizio) / 60000
            if (diffMinuti < 0) diffMinuti += 24 * 60

            this.dati.importoPrevisto = (diffMinuti / 60) * this.clienteSel.importo;
        },
    },

};
</script>

<style scoped>
.dialog-mobile {
    margin: 0 !important;
    border-radius: 0 !important;
    height: 100% !important;
}

/* ── Header ── */
.completato-banner {
    width: 100%;
    background-color: #2E7D32;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    padding: 4px 16px;
    display: flex;
    align-items: center;
}

.header-content {
    width: 100%;
    padding: 12px 16px 14px;
    transition: background-color 0.25s ease;
}

.header-meta {
    display: flex;
    align-items: center;
    color: rgba(255, 255, 255, 0.9);
    font-size: 13px;
}

/* ── Tipo toggle ── */
.tipo-toggle {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.tipo-btn {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 20px;
    border: 1.5px solid rgba(255, 255, 255, 0.55);
    color: rgba(255, 255, 255, 0.85);
    font-size: 12px;
    font-weight: 500;
    background: transparent;
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s, color 0.15s;
    white-space: nowrap;
}

.tipo-btn:hover {
    background: rgba(255, 255, 255, 0.18);
    border-color: rgba(255, 255, 255, 0.9);
    color: #fff;
}

.tipo-btn--active {
    background: rgba(255, 255, 255, 0.28);
    border-color: #fff;
    color: #fff;
    font-weight: 700;
}

.tipo-btn--readonly {
    cursor: default;
    pointer-events: none;
}

/* ── Section labels ── */
.section-label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    color: #9e9e9e;
    margin-bottom: 4px;
    display: flex;
    align-items: center;
}

/* ── Giorno toggle ── */
.giorno-toggle {
    border-radius: 8px !important;
}

/* ── Durata chips ── */
.durata-chips {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
    margin-top: 4px;
}

.durata-label {
    font-size: 11px;
    color: #9e9e9e;
    margin-right: 2px;
}

/* ── Completato button ── */
.completato-btn {
    text-transform: none !important;
    letter-spacing: 0 !important;
    border-radius: 8px !important;
    height: 36px !important;
}
</style>